"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRouteParsers = createRouteParsers;
const app_1 = require("@kalkulacka-one/app");
const validators_1 = require("../validators/index.js");
const SEGMENT = /^[a-z0-9]+(-[a-z0-9]+)*$/;
function createRouteParsers({ pageSlugs, i18n, routes }) {
    function parseQuestionNumber(path) {
        const segments = path.split("/").filter(Boolean);
        const questionIndex = (() => {
            for (const slugs of Object.values(pageSlugs)) {
                const index = segments.indexOf(slugs.question);
                if (index !== -1)
                    return index;
            }
            return -1;
        })();
        if (questionIndex === -1) {
            throw new Error("Question segment not found in path");
        }
        const questionNumberString = segments[questionIndex + 1];
        if (!questionNumberString) {
            throw new Error("Missing question number in path");
        }
        if (segments[questionIndex + 2]) {
            throw new Error("Unexpected path segments after question number");
        }
        return (0, validators_1.validateQuestionNumber)(questionNumberString);
    }
    // A route of this app (inside the same embed), returned as `routes` builds it, or nothing.
    function parseLauncherPath(path, embed) {
        const parts = path.split("/").slice(1);
        const locale = i18n.locales.includes(parts[0] ?? "") ? parts.shift() : i18n.defaultLocale;
        const launcherEmbed = parts[0] === "embed" ? parts.splice(0, 2)[1] : undefined;
        const [first, second, third, ...rest] = parts;
        if (!locale || launcherEmbed !== embed || !first || rest.length > 0 || !parts.every((part) => SEGMENT.test(part)))
            return undefined;
        const launcher = routes.base({ first, second, third, embed }, locale);
        return launcher === path ? launcher : undefined;
    }
    // A calculator picker opened from the district picker carries that one as its own `?from=`.
    function parseLauncher(value, embed) {
        if (typeof value !== "string")
            return undefined;
        const [path = "", query, ...rest] = value.split("?");
        const launcher = parseLauncherPath(path, embed);
        if (!launcher || query === undefined)
            return launcher;
        const params = new URLSearchParams(query);
        const parent = parseLauncherPath(params.get(app_1.LAUNCHER_PARAM) ?? "", embed);
        return parent && rest.length === 0 && params.size === 1 ? (0, app_1.addLauncherParam)(launcher, parent) : undefined;
    }
    const parsedParams = {
        questionNumber: (path) => parseQuestionNumber(path),
        launcher: (value, embed) => parseLauncher(value, embed),
    };
    return { parsedParams };
}
